import {
  API_ENDPOINT,
  useClientApiV1NotesIdDeleteMutation,
} from '../../resources/@types/uccSchema';

function useNoteIdDeleteMutation(
  id: string,
  options?: Parameters<typeof useClientApiV1NotesIdDeleteMutation>[0]['options'],
) {
  return useClientApiV1NotesIdDeleteMutation({
    url: API_ENDPOINT.CLIENT_V1_NOTES_ID(id),
    options,
  });
}

export default useNoteIdDeleteMutation;
